import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import arrowdown from '../assets/arrow-down-simple.png';
import eye from '../assets/eye-svgrepo-com (2).svg';
import edit from '../assets/edit-3-svgrepo-com.svg';
import deleteicon from '../assets/delete-2-svgrepo-com.svg';
import leftarrow from '../assets/left-arrow-backup-2-svgrepo-com.svg';
import rightarrow from '../assets/right-arrow-backup-2-svgrepo-com.svg';
import { FaChevronDown } from "react-icons/fa";
import CustomDarkCheckbox from "./CustomDarkCheckbox";
import toast from "react-hot-toast";
import { deleteUser, fetchCustomers, formatCustomerRow } from "../services/userService";

const CustomersTable = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [customersData, setCustomersData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });
  const [openItems, setOpenItems] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [customerToDelete, setCustomerToDelete] = useState(null);

  const CustomersPerPage = 8;

  const loadCustomers = async () => {
    try {
      setLoading(true);
      const data = await fetchCustomers(1, 100);
      if (data.status === "success" && Array.isArray(data.data)) {
        setCustomersData(data.data.map(formatCustomerRow));
      } else {
        setCustomersData([]);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      toast.error(error?.friendlyMessage || "Failed to load customers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCustomers();
    const interval = setInterval(loadCustomers, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // ✅ حساب الصفحات
  const indexOfLast = currentPage * CustomersPerPage;
  const indexOfFirst = indexOfLast - CustomersPerPage;
  const currentCustomers = customersData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(customersData.length / CustomersPerPage);

  const toggleCustomer = (id) => {
    setOpenItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleSelectAll = () => {
    if (selectedCustomers.length === currentCustomers.length) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(currentCustomers.map((c) => c.id));
    }
  };

  const toggleSelectCustomers = (id) => {
    if (selectedCustomers.includes(id)) {
      setSelectedCustomers(selectedCustomers.filter((cid) => cid !== id));
    } else {
      setSelectedCustomers([...selectedCustomers, id]);
    }
  };

  const sortedCustomers = [...customersData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const handlePageSelect = (page) => {
    setCurrentPage(page);
    setIsOpen(false);
  };

  const handleEditCustomer = (userData) => {
    navigate(`/Users/edit-User/${userData.id}`, {
      state: { activeTab: "Customers", user: userData },
    });
  };

  const openDeleteModal = (customer) => {
    setCustomerToDelete(customer);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!customerToDelete) return;
    try {
      await deleteUser(customerToDelete.id);
      setCustomersData((prev) => prev.filter((c) => c.id !== customerToDelete.id));
      toast.success("Customer deleted");
    } catch (error) {
      toast.error(error?.friendlyMessage || "Failed to delete customer");
    } finally {
      setShowDeleteModal(false);
      setCustomerToDelete(null);
    }
  };

  if (loading) {
    return <p className="py-8 text-center text-agarly-gray">Loading customers...</p>;
  }

  return (
    <div>
      <div className="overflow-hidden rounded-xl border border-gray-300 dark:border-[#3D3D3D] shadow-md">
        <table className="min-w-full border-collapse bg-white dark:bg-[#1A1A1B] hidden sm:table md:table">
          <thead className="min-w-full bg-gray-100 border-b border-[#E7E7E7] dark:bg-black dark:border-[#3D3D3D] dark:text-gray-400">
            <tr>
              <th className="flex justify-between text-left px-4 py-4 text-black text-sm font-medium select-none dark:text-gray-200">
                <div className="flex gap-4">
                  <CustomDarkCheckbox
                    checked={
                      selectedCustomers.length === currentCustomers.length &&
                      currentCustomers.length > 0
                    }
                    onChange={toggleSelectAll}
                  />
                  Customer
                </div>
              </th>
              <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                Contact
              </th>
              <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                Purchases
              </th>
              <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                Order QTY
              </th>
              <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                Address
              </th>
              <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-200">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedCustomers.length === 0 ? (
              <tr>
                <td
                  colSpan={8}
                  className="px-4 py-4 text-center text-gray-500 dark:text-gray-200"
                >
                  No Customers found.
                </td>
              </tr>
            ) : (
              currentCustomers.map((c) => (
                <tr
                  key={c.id}
                  className="border-b border-gray-200 hover:bg-gray-50 dark:hover:bg-[#2D2D2D] dark:border-[#3D3D3D]"
                >
                  <td className="flex pl-4 items-center">
                    <CustomDarkCheckbox
                      checked={selectedCustomers.includes(c.id)}
                      onChange={() => toggleSelectCustomers(c.id)}
                    />
                    <div className="flex items-center gap-3 px-4 py-3 text-gray-800 text-sm">
                      <div>
                        <p className="text-xs agarly-gradient-text">
                          ID {c.id}
                        </p>
                        <p className="text-gray-700 in-line dark:text-gray-300">
                          {c.name}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                    {c.email}
                    <br />
                    {c.phone}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                    ${c.purchases}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                    {c.orderqty}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm dark:text-gray-300">
                    {c.address}
                  </td>
                  <td className="items-center px-4 py-3 text-gray-700 text-sm flex gap-4 dark:text-gray-300">
                    <Link
                      to={`/Users/customers/view-Customer/${c.id}`}
                      state={{ customer: c }}
                    >
                      <img src={eye} alt="eye" className="w-5 h-5 inline" />
                    </Link>
                    <button onClick={() => handleEditCustomer(c)}>
                      <img src={edit} alt="edit" className="w-5 h-5 inline" />
                    </button>
                    <button onClick={() => openDeleteModal(c)}>
                      <img src={deleteicon} alt="delete" className="w-5 h-5 inline" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Delete Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg p-6 w-80 text-center shadow-lg dark:bg-black">
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Are you sure you want to delete{" "}
              <strong>{customerToDelete.name}</strong>?
            </p>
            <div className="flex justify-between">
              <button
                className="px-4 py-2 rounded bg-gray-300 text-gray-700 hover:bg-gray-400"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Mobile View */}
      <div className="md:hidden bg-white flex flex-col items-start p-5 gap-6 w-full border border-[#E7E7E7] rounded-2xl shadow-md mt-6 dark:bg-[#1A1A1B]">
        {currentCustomers.map((c) => (
          <div key={c.id} className="relative w-full border-b border-gray-200 dark:border-[#3D3D3D]">
            <div className="flex justify-between items-center w-full py-3 px-4">
              <div className="flex gap-3 items-center">
                <div>
                  <p className="text-xs agarly-gradient-text">
                    ID {c.id}
                  </p>
                  <p className="dark:text-gray-300">{c.name}</p>
                </div>
              </div>
              <button onClick={() => toggleCustomer(c.id)}>
                <img
                  src={arrowdown}
                  alt="toggle"
                  className={`w-5 h-5 transition-transform ${openItems[c.id] ? "rotate-180" : ""}`}
                />
              </button>
            </div>

            {openItems[c.id] && (
              <div className="bg-white w-full rounded-lg p-4 mt-1 dark:bg-[#1A1A1B]">
                <div className="text-gray-900 text-sm mb-2 flex gap-2">
                  <span className="text-gray-500 dark:text-gray-300">Contact:</span>
                  <div className="flex flex-col flex-1 break-words dark:text-gray-400">
                    {c.email} <br /> {c.phone}
                  </div>
                </div>

                <div className="text-gray-900 text-sm mb-2 dark:text-gray-400">
                  <span className="text-gray-500 dark:text-gray-300">Purchases: </span>${c.purchases}
                </div>

                <div className="text-gray-900 text-sm mb-2 dark:text-gray-400">
                  <span className="text-gray-500 dark:text-gray-300">Orders: </span>{c.orderqty}
                </div>

                <div className="text-gray-900 text-sm mb-2 flex gap-2">
                  <span className="text-gray-500 dark:text-gray-300">Address:</span>
                  <span className="flex flex-col flex-1 break-words dark:text-gray-400">{c.address}</span>
                </div>

                <div className="flex gap-2 text-gray-900 text-sm mb-2">
                  <span className="text-gray-500 dark:text-gray-300">Actions:</span>
                  <div className="flex gap-4">
                    <Link to={`/Users/customers/view-Customer/${c.id}`} state={{ customer: c }}>
                      <img src={eye} alt="eye" className="w-5 h-5 inline" />
                    </Link>
                    <button onClick={() => handleEditCustomer(c)}>
                      <img src={edit} alt="edit" className="w-5 h-5 inline" />
                    </button>
                    <button onClick={() => openDeleteModal(c)}>
                      <img src={deleteicon} alt="delete" className="w-4 h-4 inline" />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ✅ Pagination */}
      <div className="flex justify-between items-center mt-4">
        <p className="text-sm text-gray-700 dark:text-gray-400">
          <span className="dark:text-gray-200">{currentPage}</span> of {totalPages} Pages
        </p>
        <div className="flex gap-2 items-center">
          <button
            className="border-2 px-1 py-1 rounded-xl disabled:opacity-50"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            <img src={leftarrow} alt="previous" className="w-5 h-5" />
          </button>

          <div className="relative inline-block">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex items-center gap-1 border px-2 py-1 rounded-xl dark:text-gray-200"
            >
              {currentPage} <FaChevronDown />
            </button>

            {isOpen && (
              <div className="absolute bg-white border rounded-md shadow z-10 mb-10">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                  <div
                    key={p}
                    onClick={() => handlePageSelect(p)}
                    className={`px-3 py-1 cursor-pointer ${
                      p === currentPage ? "bg-gray-200 font-semibold" : ""
                    }`}
                  >
                    {p}
                  </div>
                ))}
              </div>
            )}
          </div>

          <button
            className="border-2 px-1 py-1 rounded-xl disabled:opacity-50"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            <img src={rightarrow} alt="next" className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomersTable;
